'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_AdHoc$package$$anon$5(evaluator$6) {
  this.KD = null;
  this.KD = evaluator$6;
}
export { $c_Lsamples_AdHoc$package$$anon$5 as $c_Lsamples_AdHoc$package$$anon$5 };
$p = $c_Lsamples_AdHoc$package$$anon$5.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_AdHoc$package$$anon$5;
/** @constructor */
function $h_Lsamples_AdHoc$package$$anon$5() {
}
export { $h_Lsamples_AdHoc$package$$anon$5 as $h_Lsamples_AdHoc$package$$anon$5 };
$h_Lsamples_AdHoc$package$$anon$5.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.KD.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_AdHoc$package$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_AdHoc$package$$anon$5, "samples.AdHoc$package$$anon$5", ({
  o3: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_AdHoc$package$$anon$5 as $d_Lsamples_AdHoc$package$$anon$5 };
